<template>
  <div>
    <Navbar></Navbar>
    <div class="section_1">
      <div class="content-box">
        <div class="title">
        <p>Detect the arrhythmia risk and</p>
        <p style="position: relative;">mental stress with Heart Smart<span style="font-size: 36px;position: absolute; top:0px;margin-right: 5px;">™</span></p>
        <p>heart monitor at anytime</p>
      </div>
      <div class="smart">No need to ship it back, it is yours!</div>
      </div>
    </div>
    <div class="section_3">
      <div class="title">How it works</div>
      <div class="trait-list">
        <div class="trait-item">
          <div class="circle">1</div>
          <div class="title-text">Connect it</div>
          <div class="info-text">
            <p>Connect the monitor</p>
            <p>to cell phone</p>
          </div>
          <div class="img-info"><img src="@/assets/2.0/icon-01.svg" /></div>
        </div>
        <div class="trait-item">
          <div class="circle">2</div>
          <div class="title-text">Wear it</div>
          <div class="info-text">
            <p>Wear the monitor patch</p>
            <p>to your chest</p>
          </div>
          <div class="img-info"><img src="@/assets/2.0/icon-03.svg" /></div>
        </div>
        <div class="trait-item">
          <div class="circle">3</div>
          <div class="title-text">Use it</div>
          <div class="info-text">
            <p>Monitor your heart and</p>
            <p>stress at anytime</p>
          </div>
          <div class="img-info"><img src="@/assets/2.0/icon-02.svg" /></div>
        </div>
        <div class="trait-item">
          <div class="circle">4</div>
          <div class="title-text">Read it</div>
          <div class="info-text">
            <p>Download and read</p>
            <p>your report after</p>
          </div>
          <div class="img-info"><img src="@/assets/2.0/icon-04.svg" /></div>
        </div>
      </div>
    </div>
    <div class="section_4">
      <div class="title">
        <p>Download App today</p>
      </div>
      <div class="info">
        <p>The HMApp paired with the Micro allows you to check your heart status lively,</p>
        <p>log the data to server and perform analysis for you</p>
      </div>
      <div class="table-img"><img src="@/assets/2.0/mobile.png" /></div>
      <div class="table-list">
        <img src="@/assets/2.0/apple-store.png" @click="download('ios')"/>
        <img src="@/assets/2.0/google-play.png" @click="download('android')"/>
      </div>

    </div>
    <FooterDom></FooterDom>
  </div>
</template>

<script>
import Navbar from "./components/navbar.vue";
import FooterDom from "./components/footerEle.vue";

export default {
  name: "index",
  components: {
    Navbar,
    FooterDom
  },
  data() {
    return {

    };
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    download(type){
      const url = type ==="ios" ? process.env.VUE_APP_IOS_HOST : process.env.VUE_APP_ANDROID_HOST 
      window.open(url,'_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.content-box{
  max-width: 1920px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.section_1{
  width: 100%;
  height: 627px;
  background: url("../../assets/2.0/w_section_1_bg.png") no-repeat;
  background-size: cover;
  background-position: center;

  .title{
    font-size: 48px;
    color: #000;
    padding-top: 120px;
    margin-left: 276px;
  }
  .smart{
    margin-left: 276px;
    font-size: 24px;
    color: #000;
    margin-top: 20px;

  }
}

.section_3{
  width: 100%;
  height: 768px;
  .title{
    font-size: 53px;
    color: #000;
    width: 100%;
    text-align: center;
    padding-top: 60px;
    margin-bottom: 100px;

  }
  .trait-list{
    width: 100%;
    // height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;

    .trait-item{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 0 60px;
      position: relative;
      &::after{
        content: "";
        width: 1px;
        height: 140px;
        position: absolute;
        top: 41%;
        right: 0;
        margin-top: -70px;
        border-right: 0.5px solid #000;
      }
      &:last-child{
        &::after{
          display: none;
        }
        padding: 0 0 0 60px;
      }
      &:first-child{
        padding: 0 60px 0 0;
      }
    }
    .circle{
      width: 65px;
      height: 65px;
      border-radius: 65px;
      border: 1px solid #000;
      font-size: 36px;
      text-align: center;
      line-height: 65px;
    }
    .title-text{
      font-size: 42px;
      margin-top: 60px;
      font-family: "Light";
    }
    .info-text{
      font-size: 24px;
      margin-top: 30px;
      p{
        text-align: center;
      }
    }
    .img-info{
      height: 102px;
      margin-top: 120px;
      img{
        height: 100%;
      }
    }
  }
}

.section_4{
  width: 100%;
  // height: 909px;
  background: #efefef;
  padding-top: 60px;
  .title{
    p{
      text-align: center;
    }

    font-size: 42px;
    width: 100%;

  }
  .info{
    margin-top: 20px;
    font-size: 24px;
    width: 100%;
    text-align: center;
    p{
      text-align: center;
    }
  }
  .table-list{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 40px;
    padding-bottom: 60px;

    img{
        width: 179px;
        margin-left: 30px;
        cursor: pointer;
        &:last-child{
          margin-right: 0;
        }
      }
  }
  .table-img{
      max-width: 1058px;
      margin: 120px auto 0 auto;
      img{
        width: 100%;
        cursor: pointer;
      }
    }
}
/* 桌面显示器，小于 1800px） */
@media (max-width: 1800px) {
  .section_1{
    .title{
      font-size: 30px;
    }
    .smart{
      font-size: 18px;
    }
  }
}
/* 桌面显示器，小于 1200px） */
@media (max-width: 1200px) {
  .section_1{
    .title{
    margin-left: 66px;
  }
  .smart{
    margin-left: 66px;
  }
  }
  .section_3{
      .trait-list{
      .title-text {
        font-size: 30px;
        margin-top: 40px;
      }
      .info-text {
        font-size: 18px;
        margin-top: 20px;
      }
      .trait-item{
        padding: 0 40px;
        &:last-child{
         padding: 0 0 0 40px;
        }
        &:first-child{
          padding: 0 40px 0 0;
        }
      }
      .img-info{
        margin-top: 60px;
      }
    }
  }
}
/* 桌面显示器，小于 992px） */
@media (max-width: 992px) {
  .section_1{
    .title{
    font-size: 30px;
    }
  }
  .section_3{
    height: auto;
    padding: 60px 0;
      .trait-list{

        flex-direction: column;
      .title-text {
        font-size: 40px;
        margin-top: 40px;
      }
      .info-text {
        font-size: 20px;
        margin-top: 20px;
      }
      .trait-item{
        width: 50%;
        padding: 40px 0;
        &::after{
          content: "";
          width: 100%;
          height: auto;
          position: absolute;
          left: 0%;
          bottom: 0;
          border-bottom: 0.5px solid #000;
          border-right: none;
        }
      &:last-child{
        &::after{
          display: none;
        }
        padding: 40px 0 0 0;
      }
        &:first-child{
          padding: 0 0px 40px 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/howWork.vue